// extracted by mini-css-extract-plugin
export default {"page":"gS-z","cartModal":"hS-z","checkout":"iS-z","placeholder":"jS-z","account":"kS-z"};